export const NIGHTANGLE_PAGE_CONFIG = {
  title: 'Realtime Steam Units',
  titleCN: '实时Steam销量',
  subTitle: 'Timezone (UTC-8)',
  subTitleCN: '时区 (UTC-8)',
  path: '/realtime/steam',
  defaultTab: 'steam',
  tabList: [
    {
      id: 'steam',
      tabName: 'Steam',
      tabNameCN: 'Steam',
      isHaveNotification: true,
      refresh: true,
      refreshConfig: {
        contentEn: 'Click to refresh or auto refresh every 1 hour.',
        contentCn: '单击可刷新或每小时自动刷新一次.'
      },
      notificationPath: '/realtime/steam',
      path: '/realtime/steam',
      tabIcon: '',
      logConfig: {
        pageId: '205401',
        pageName: 'realtimeSteam',
        extInfo: 'realtimeSteam',
        pagePath: '/realtime/steam',
      },
      filters: [
        {
          name: 'RealtimeSteamFilter',
          isOpenSticky: false,
          isHaveFilterSave: false,
          filterPath: '/realtime/steam',
          componentList: [
            {
              name: 'realtimeSteamService',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/event_analysis/realtime/date_event_list',
                  dataKey: 'date_event_list',
                  refreshKey:'realtime_user_date_event_list',
                  interval:3600000
                }
              },
              children: [
                {
                  name: 'realtimeSteamService',
                  className: '',
                  type: 'view',
                  style: {},
                  props: {
                    config: {
                      api: '/api/v1/dashboard/pc/realtime/steam_trend',
                      dataKey: 'steam_trend',
                      refreshKey:'realtime_steam',
                      interval:3600000
                    }
                  },
                  children: [
                    {
                      name: 'RealtimeSteamContext',
                      props: {
                        config: {
                          title: 'Realtime Daily Accumulated Steam Units (1h)',
                          titleCn: '每日实时累计Steam销量（1小时）',
                          formatTitle: 'realtime_steam_realtime_steam_title',
                          explain:'Statistical Time: {{lastUpdateTime|string}} The data comes from the Steam backend, with a one-hour delay on Steam platform data.In addition, current unit data excludes third-party sales and activations via activation codes.',
                          explainCn:'统计时间: {{lastUpdateTime|string}} 数据来源于Steam后台，Steam平台数据有1小时延迟，另外当前unit数据已剔除第三方销售和激活码激活的情况。',
                          redExplain:'Timezone (UTC-8)',
                          redExplainCn:'时区 (UTC-8)',
                          apiDataKey: 'steam_trend',
                          titleIcon:'steam',
                          className:'dbd-realtime-steam-box',
                          dataType: '',
                          table: {
                            option: [{
                              key: 'time',
                              align: 'left',
                              fixed: 'left',
                              width: 100,
                              title: 'Time',
                              titleCn: '时间',
                              formatTitle: 'realtime_by_country_table_time',
                              valueKey: 'time'
                            }, {
                              key: 'line_dot',
                              align: 'right',
                              fixed: '',
                              width: 100,
                              title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                              titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}',
                              valueKey: 'lineDot',
                              format: '#,##0',
                              type: 'number'
                            }, {
                              key: 'line_dot_last',
                              align: 'right',
                              fixed: '',
                              width: 100,
                              title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                              titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                              valueKey: 'lineDotLast',
                              format: '#,##0',
                              type: 'number'
                            }, {
                              key: 'line_dot_contrast',
                              align: 'right',
                              fixed: '',
                              width: 100,
                              title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day',
                              titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日',
                              valueKey: 'lineDotContrast',
                              changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                              changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                              format: '#,##0',
                              type: 'number'
                            }],
                            sort: true,
                            columns: ['time'],
                            defaultValue: [{ by: 'time', order: 'desc' }],
                            isRealTime: true,
                            height: 350
                          },
                          subTitle: [{
                            title: 'DoD',
                            titleCn: '日环比',
                            formatTitle: '',
                            valueKey: 'dod',
                            unit: 'percent',
                            bold: true
                          }, {
                            title: 'SDLW',
                            titleCn: '上周同期',
                            formatTitle: '',
                            valueKey: 'sdlw',
                            unit: 'percent',
                            bold: true
                          }],
                          event: {
                            show: true,
                            link: 'eventAnalysis/eventDetails',
                            dataKey: 'date_event_list',
                            timeType: 'Hour',
                            cssStyle: { top: '82%' }
                          },
                          chart: {
                            type: 'line',
                            series: [{
                              valueKey: 'line_dot',
                              title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                              titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}'
                            }, {
                              valueKey: 'line_dot_last',
                              title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                              titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',

                            }, {
                              valueKey: 'line_dot_contrast',
                              title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)',
                              titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)',
                              changeDateTitle: 'Contrast Day {{contrastDaily|date|YYYY-MM-DD}}',
                              changeDateTitleCn: '对比日 {{contrastDaily|date|YYYY-MM-DD}}',
                            }],
                            tooltip: {
                              title: 'Steam Units',
                              titleCn: 'Steam销量',
                              formatTitle: 'realtime_steam_units'
                            },
                            height: 350
                          },
                          downloadOptions:{
                            timeScale : 60, 
                            sort : 1
                          },
                          noDataDisplay: true
                        }
                      }
                    }
                  ]
                }
              ]
            },
          ]
        },
      ],
    },
  ]
}